import $api from '../api/index';
import { normalizeRelations, resolveRelations } from './helpers';
import { camelCase, pascalCase } from '../helpers';

const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  // Return a single assignment with the given id
  find: (state, _, __, rootGetters) => id =>
    resolveRelations(state.byId[id], ['modules'], rootGetters)
};

const actions = {
  async getAssignments({ commit, dispatch, rootState }, payload) {
    const { assignmentId } = payload;
    payload.location = payload.location || 'pass';
    let { isPreview = false, isUnregisteredLink = false } =
      rootState?.offer || {};
    let partnerUserId =
      rootState?.partnerUser?.id || rootState?.partnerUser?.partnerUser?.id;

    if (!isPreview && !isUnregisteredLink && !partnerUserId) {
      await dispatch('initialData/getInitialData', null, { root: true });

      ;({ isPreview = false, isUnregisteredLink = false } =
        rootState?.offer || {});
      partnerUserId =
        rootState?.partnerUser?.id || rootState?.partnerUser?.partnerUser?.id;
    }

    if (!isPreview && !isUnregisteredLink && !partnerUserId) {
      throw new Error('partnerUserId is required to load assignments');
    }

    const { data } = await $api.assignments.getAssignments(payload, rootState);

    Object.keys(data.data || {}).forEach(field => {
      const moduleAddPath = `${camelCase(field)}/add${pascalCase(field)}`;
      dispatch(moduleAddPath, data.data[field], { root: true });
    });

    const deals = data.data?.deals ?? data.deals;
    const bingoPayload = data.data?.bingo ?? data.bingo;
    if (Array.isArray(deals) && payload.type === 'deal') {
      const dealId = parseInt(assignmentId, 10);
      const deal = deals.find(
        d => (d.id != null && d.id === dealId) || (d.deal_id != null && d.deal_id === dealId)
      );
      if (deal?.has_bingo && bingoPayload) {
        dispatch('bingo/addBingo', bingoPayload, { root: true });
      } else {
        dispatch('bingo/resetBingo', null, { root: true });
      }
    }

    const assignment = {
      id: assignmentId,
      modules: data.modules
    };

    // Normalize relations before storing
    commit('add', normalizeRelations(assignment, ['modules']));

    // Add each module to module store
    assignment.modules.forEach(module => {
      dispatch('modules/addModule', module, { root: true });
    });
  }
};

const mutations = {
  add(state, item) {
    state.byId[item.id] = item;

    if (!state.allIds.includes(item.id)) {
      state.allIds.push(item.id);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
